import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import ReactApexChart from "react-apexcharts";
import { Box, Typography, Card, CardContent, CircularProgress } from "@mui/material";
import { AuthContext } from "../../../../authentication/AuthContext";
import analyticsService from "../../../../services/analyticsService";
import { getDateRangeFromFilter } from "../../../../utils/dateFilterUtils";

import ViewDetailsBtn from "../ViewDetailsBtn/ViewDetailsBtn"; // ⭐ Reusable button

const ProductRecommendationPurchaseFunnel = ({ dateFilterValue }) => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [funnelData, setFunnelData] = useState(null);

  useEffect(() => {
    const fetchFunnelData = async () => {
      try {
        if (!user?.client_id) {
          console.warn("⚠️ Client ID not available");
          setLoading(false);
          return;
        }

        // Convert filter to actual dates (with default if not provided)
        const { start_date, end_date } = getDateRangeFromFilter(dateFilterValue || "Last 3 months");

        const response = await analyticsService.getProductRecommendationFunnel(
          user.client_id,
          start_date,
          end_date
        );

        if (response.success && response.data && response.data.length > 0) {
          const data = response.data[0];
          setFunnelData(data);
          console.log("✅ Funnel data loaded:", data);
        } else {
          console.warn("⚠️ No funnel data returned");
        }
      } catch (error) {
        console.error("❌ Error fetching funnel data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFunnelData();
  }, [user?.client_id, dateFilterValue]);

  // Calculate percentages for display
  const suggested = funnelData?.suggested_count || 0;
  const clicked = funnelData?.clicked_count || 0;
  const purchased = funnelData?.purchased_count || 0;

  const state = {
    series: [
      {
        name: "Funnel Series",
        data: [suggested, clicked, purchased],
      },
    ],

    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: { show: false },
      },

      plotOptions: {
        bar: {
          horizontal: true,
          isFunnel: true,
          barHeight: "48%",
          borderRadius: 6,
        },
      },

      fill: {
        type: "solid",
        colors: ["#6f42c1", "#6f42c1", "#6f42c1"],
      },

      dataLabels: {
        enabled: true,
        formatter: function (val, opt) {
          const values = [suggested, clicked, purchased];
          return values[opt.dataPointIndex] || 0;
        },
        style: {
          fontSize: "16px",
          fontWeight: 700,
          colors: ["#ffffff"],
        },
      },

      xaxis: {
        categories: [
          "Suggested",
          "Clicked",
          "Purchased",
        ],
        max: suggested || 1500,
        labels: { show: false },
      },

      yaxis: {
        labels: { show: false },
      },

      grid: { show: false },
      legend: { show: false },
      tooltip: { enabled: false },
    },
  };

  return (
    <Box width="100%" p={0} display="flex" flexDirection="column" gap={3}>

      <Card sx={{ width: "100%", borderRadius: 3, boxShadow: "0 4px 12px rgba(0,0,0,0.08)" }}>
        <CardContent>

          {/* ⭐ Header (Heading + Button) */}
          <Box display="flex" alignItems="center" mb={2}>
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{
                color: "#1E1E1E",
                flexGrow: 1,        // heading expands fully
                whiteSpace: "nowrap", // no wrap
                flexShrink: 0,
              }}
            >
              Product Recommendation → Purchase Funnel
            </Typography>

            <ViewDetailsBtn
              redirectTo="/analytics/product-funnel/details"
              align="right"
              dateFilterValue={dateFilterValue}
            />
          </Box>

          {/* Chart or Loading */}
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "350px" }}>
              <CircularProgress />
            </Box>
          ) : (
            <>
              <ReactApexChart
                options={state.options}
                series={state.series}
                type="bar"
                height={350}
              />

              {/* Bottom labels */}
              <Box
                display="flex"
                justifyContent="space-around"
                mt={1.5}
                sx={{ fontSize: "14px", color: "#525252", fontWeight: 600 }}
              >
                <span>Suggested</span>
                <span>Clicked</span>
                <span>Purchased</span>
              </Box>
            </>
          )}

        </CardContent>
      </Card>

    </Box>
  );
};

export default ProductRecommendationPurchaseFunnel;


// import React from "react";
// import { useNavigate } from "react-router-dom";
// import ReactApexChart from "react-apexcharts";
// import { Box, Button, Typography, Card, CardContent } from "@mui/material";
 
// const ProductRecommendationPurchaseFunnel = () => {
//   const navigate = useNavigate();
 
//   const [state] = React.useState({
//     series: [
//       {
//         name: "Funnel Series",
//         data: [1200, 600, 150],
//       },
//     ],
 
//     options: {
//       chart: {
//         type: "bar",
//         height: 350,
//         toolbar: { show: false },
//       },
 
//       plotOptions: {
//         bar: {
//           horizontal: true,
//           isFunnel: true,
//           barHeight: "48%",
//           borderRadius: 6,
//         },
//       },
 
//       // ⭐ Updated Graph Color (Trezo Purple)
//       fill: {
//         type: "solid",
//         colors: ["#6f42c1", "#6f42c1", "#6f42c1"],
//       },
 
//       dataLabels: {
//         enabled: true,
//         formatter: function (val, opt) {
//           const percentages = ["12.0%", "6.0%", "1.5%"];
//           return percentages[opt.dataPointIndex];
//         },
//         style: {
//           fontSize: "16px",
//           fontWeight: 700,
//           colors: ["#ffffff"],
//         },
//       },
 
//       xaxis: {
//         categories: [
//           "Product Page Views",
//           "Added to Cart",
//           "Completed Purchase",
//         ],
//         max: 1500,
//         labels: { show: false },
//       },
 
//       yaxis: {
//         labels: { show: false },
//       },
 
//       grid: { show: false },
//       legend: { show: false },
//       tooltip: { enabled: false },
//     },
//   });
 
//   return (
//     <Box width="100%" p={0} display="flex" flexDirection="column" gap={3}>
     
//       <Card sx={{ width: "100%", borderRadius: 3, boxShadow: "0 4px 12px rgba(0,0,0,0.08)" }}>
//         <CardContent>
         
//           <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
           
//             <Typography variant="h6" fontWeight={700} sx={{ color: "#1E1E1E" }}>
//               Product Recommendation → Purchase Funnel
//             </Typography>
 
//             <Button
//               variant="contained"
//               size="small"
//               onClick={() => navigate("/analytics/product-funnel/details")}
//               sx={{
//                 borderRadius: "8px",
//                 textTransform: "none",
//                 backgroundColor: "#6f42c1",
//                 "&:hover": { backgroundColor: "#5b34a0" },
//               }}
//             >
//               View Details →
//             </Button>
//           </Box>
 
//           <ReactApexChart
//             options={state.options}
//             series={state.series}
//             type="bar"
//             height={350}
//           />
 
//           <Box
//             display="flex"
//             justifyContent="space-around"
//             mt={1.5}
//             sx={{ fontSize: "14px", color: "#525252", fontWeight: 600 }}
//           >
//             <span>Product Page Views</span>
//             <span>Added to Cart</span>
//             <span>Completed Purchase</span>
//           </Box>
 
//         </CardContent>
//       </Card>
 
//     </Box>
//   );
// };
 
// export default ProductRecommendationPurchaseFunnel;